import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs as MuiTabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import LinkIcon from '@material-ui/icons/Link';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import SubjectRoundedIcon from '@material-ui/icons/SubjectRounded';

import { ComposeTab } from 'features/compose';
import { ExternalShareOption, usePostContext } from 'features/posting';

const useStyles = makeStyles(theme => ({
  tabIcon: {
    marginRight: theme.spacing(1),
  },
}));

const Tabs: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { state, dispatch } = usePostContext();

  function handleChangeTab(event: unknown, value: ExternalShareOption) {
    dispatch({ type: 'shareOption', value });
  }

  return (
    <MuiTabs
      value={state.shareOption}
      onChange={handleChangeTab}
      textColor="primary"
      indicatorColor="primary"
      variant="fullWidth"
    >
      <ComposeTab
        value={ExternalShareOption.LinkShare}
        label={
          <Fragment>
            <LinkIcon className={classes.tabIcon} />
            {t('common:link')}
          </Fragment>
        }
      />
      <ComposeTab
        value={ExternalShareOption.ImageShare}
        label={
          <Fragment>
            <AddPhotoAlternateIcon className={classes.tabIcon} />
            {t('common:image')}
          </Fragment>
        }
      />
      <ComposeTab
        value={ExternalShareOption.TextShare}
        label={
          <Fragment>
            <SubjectRoundedIcon className={classes.tabIcon} />
            {t('common:Text')}
          </Fragment>
        }
      />
    </MuiTabs>
  );
};

export default Tabs;
